import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TenantFilterDto } from '@artemis-software/wr-api';
import { houseCareContactTypeTranslations } from '@shared/pipes/house-care-contact-type-translation.pipe';

@Component({
  standalone: false,
  selector: 'wr-house-care-contacts-tab',
  templateUrl: './house-care-contacts-tab.component.html',
})
export class HouseCareContactsTabComponent {
  readonly form = input.required<FormGroup>();

  protected readonly TenantFilterTypeEnum = TenantFilterDto.TypeEnum;
  protected readonly translations = houseCareContactTypeTranslations;
}
